/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

const msg = $root.msg = (() => {

    /**
     * Namespace msg.
     * @exports msg
     * @namespace
     */
    const msg = {};

    msg.User = (function () {

        /**
         * Properties of a User.
         * @memberof msg
         * @interface IUser
         * @property {string} token User token
         * @property {string} time User time
         * @property {string} sign User sign
         * @property {msg.IDevice} device User device
         * @property {string} country User country
         */

        /**
         * Constructs a new User.
         * @memberof msg
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {msg.IUser=} [properties] Properties to set
         */
        function User(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User token.
         * @member {string} token
         * @memberof msg.User
         * @instance
         */
        User.prototype.token = "";

        /**
         * User time.
         * @member {string} time
         * @memberof msg.User
         * @instance
         */
        User.prototype.time = "";

        /**
         * User sign.
         * @member {string} sign
         * @memberof msg.User
         * @instance
         */
        User.prototype.sign = "";

        /**
         * User device.
         * @member {msg.IDevice} device
         * @memberof msg.User
         * @instance
         */
        User.prototype.device = null;

        /**
         * User country.
         * @member {string} country
         * @memberof msg.User
         * @instance
         */
        User.prototype.country = "";

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof msg.User
         * @static
         * @param {msg.IUser=} [properties] Properties to set
         * @returns {msg.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Encodes the specified User message. Does not implicitly {@link msg.User.verify|verify} messages.
         * @function encode
         * @memberof msg.User
         * @static
         * @param {msg.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.time);
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sign);
            $root.msg.Device.encode(message.device, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.country);
            return writer;
        };

        /**
         * Encodes the specified User message, length delimited. Does not implicitly {@link msg.User.verify|verify} messages.
         * @function encodeDelimited
         * @memberof msg.User
         * @static
         * @param {msg.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User message from the specified reader or buffer.
         * @function decode
         * @memberof msg.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {msg.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.msg.User();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.time = reader.string();
                        break;
                    case 3:
                        message.sign = reader.string();
                        break;
                    case 4:
                        message.device = $root.msg.Device.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.country = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            if (!message.hasOwnProperty("token"))
                throw $util.ProtocolError("missing required 'token'", { instance: message });
            if (!message.hasOwnProperty("time"))
                throw $util.ProtocolError("missing required 'time'", { instance: message });
            if (!message.hasOwnProperty("sign"))
                throw $util.ProtocolError("missing required 'sign'", { instance: message });
            if (!message.hasOwnProperty("device"))
                throw $util.ProtocolError("missing required 'device'", { instance: message });
            if (!message.hasOwnProperty("country"))
                throw $util.ProtocolError("missing required 'country'", { instance: message });
            return message;
        };

        /**
         * Decodes a User message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof msg.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {msg.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User message.
         * @function verify
         * @memberof msg.User
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.token))
                return "token: string expected";
            if (!$util.isString(message.time))
                return "time: string expected";
            if (!$util.isString(message.sign))
                return "sign: string expected";
            {
                let error = $root.msg.Device.verify(message.device);
                if (error)
                    return "device." + error;
            }
            if (!$util.isString(message.country))
                return "country: string expected";
            return null;
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof msg.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {msg.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.msg.User)
                return object;
            let message = new $root.msg.User();
            if (object.token != null)
                message.token = String(object.token);
            if (object.time != null)
                message.time = String(object.time);
            if (object.sign != null)
                message.sign = String(object.sign);
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".msg.User.device: object expected");
                message.device = $root.msg.Device.fromObject(object.device);
            }
            if (object.country != null)
                message.country = String(object.country);
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof msg.User
         * @static
         * @param {msg.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.token = "";
                object.time = "";
                object.sign = "";
                object.device = null;
                object.country = "";
            }
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.sign != null && message.hasOwnProperty("sign"))
                object.sign = message.sign;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.msg.Device.toObject(message.device, options);
            if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof msg.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    msg.Device = (function () {

        /**
         * Properties of a Device.
         * @memberof msg
         * @interface IDevice
         * @property {string|null} [lobbyVersion] Device lobbyVersion
         * @property {string|null} [deviceModel] Device deviceModel
         * @property {number|null} [deviceHeight] Device deviceHeight
         * @property {number|null} [deviceWidth] Device deviceWidth
         * @property {string|null} [osName] Device osName
         * @property {string|null} [osVersion] Device osVersion
         * @property {string|null} [macAddr] Device macAddr
         * @property {string|null} [udid] Device udid
         * @property {string|null} [isp] Device isp
         * @property {string|null} [network] Device network
         * @property {string|null} [appVersion] Device appVersion
         * @property {string|null} [imei] Device imei
         * @property {string|null} [location] Device location
         * @property {number|null} [isEmulator] Device isEmulator
         */

        /**
         * Constructs a new Device.
         * @memberof msg
         * @classdesc Represents a Device.
         * @implements IDevice
         * @constructor
         * @param {msg.IDevice=} [properties] Properties to set
         */
        function Device(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Device lobbyVersion.
         * @member {string} lobbyVersion
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.lobbyVersion = "";

        /**
         * Device deviceModel.
         * @member {string} deviceModel
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.deviceModel = "";

        /**
         * Device deviceHeight.
         * @member {number} deviceHeight
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.deviceHeight = 0;

        /**
         * Device deviceWidth.
         * @member {number} deviceWidth
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.deviceWidth = 0;

        /**
         * Device osName.
         * @member {string} osName
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.osName = "";

        /**
         * Device osVersion.
         * @member {string} osVersion
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.osVersion = "";

        /**
         * Device macAddr.
         * @member {string} macAddr
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.macAddr = "";

        /**
         * Device udid.
         * @member {string} udid
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.udid = "";

        /**
         * Device isp.
         * @member {string} isp
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.isp = "";

        /**
         * Device network.
         * @member {string} network
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.network = "";

        /**
         * Device appVersion.
         * @member {string} appVersion
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.appVersion = "";

        /**
         * Device imei.
         * @member {string} imei
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.imei = "";

        /**
         * Device location.
         * @member {string} location
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.location = "";

        /**
         * Device isEmulator.
         * @member {number} isEmulator
         * @memberof msg.Device
         * @instance
         */
        Device.prototype.isEmulator = 0;

        /**
         * Creates a new Device instance using the specified properties.
         * @function create
         * @memberof msg.Device
         * @static
         * @param {msg.IDevice=} [properties] Properties to set
         * @returns {msg.Device} Device instance
         */
        Device.create = function create(properties) {
            return new Device(properties);
        };

        /**
         * Encodes the specified Device message. Does not implicitly {@link msg.Device.verify|verify} messages.
         * @function encode
         * @memberof msg.Device
         * @static
         * @param {msg.IDevice} message Device message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Device.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lobbyVersion != null && message.hasOwnProperty("lobbyVersion"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.lobbyVersion);
            if (message.deviceModel != null && message.hasOwnProperty("deviceModel"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.deviceModel);
            if (message.deviceHeight != null && message.hasOwnProperty("deviceHeight"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.deviceHeight);
            if (message.deviceWidth != null && message.hasOwnProperty("deviceWidth"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.deviceWidth);
            if (message.osName != null && message.hasOwnProperty("osName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.osName);
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.osVersion);
            if (message.macAddr != null && message.hasOwnProperty("macAddr"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.macAddr);
            if (message.udid != null && message.hasOwnProperty("udid"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.udid);
            if (message.isp != null && message.hasOwnProperty("isp"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.isp);
            if (message.network != null && message.hasOwnProperty("network"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.network);
            if (message.appVersion != null && message.hasOwnProperty("appVersion"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.appVersion);
            if (message.imei != null && message.hasOwnProperty("imei"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.imei);
            if (message.location != null && message.hasOwnProperty("location"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.location);
            if (message.isEmulator != null && message.hasOwnProperty("isEmulator"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.isEmulator);
            return writer;
        };

        /**
         * Encodes the specified Device message, length delimited. Does not implicitly {@link msg.Device.verify|verify} messages.
         * @function encodeDelimited
         * @memberof msg.Device
         * @static
         * @param {msg.IDevice} message Device message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Device.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Device message from the specified reader or buffer.
         * @function decode
         * @memberof msg.Device
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {msg.Device} Device
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Device.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.msg.Device();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.lobbyVersion = reader.string();
                        break;
                    case 2:
                        message.deviceModel = reader.string();
                        break;
                    case 3:
                        message.deviceHeight = reader.int32();
                        break;
                    case 4:
                        message.deviceWidth = reader.int32();
                        break;
                    case 5:
                        message.osName = reader.string();
                        break;
                    case 6:
                        message.osVersion = reader.string();
                        break;
                    case 7:
                        message.macAddr = reader.string();
                        break;
                    case 8:
                        message.udid = reader.string();
                        break;
                    case 9:
                        message.isp = reader.string();
                        break;
                    case 10:
                        message.network = reader.string();
                        break;
                    case 11:
                        message.appVersion = reader.string();
                        break;
                    case 12:
                        message.imei = reader.string();
                        break;
                    case 13:
                        message.location = reader.string();
                        break;
                    case 14:
                        message.isEmulator = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };

        /**
         * Decodes a Device message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof msg.Device
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {msg.Device} Device
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Device.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Device message.
         * @function verify
         * @memberof msg.Device
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Device.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lobbyVersion != null && message.hasOwnProperty("lobbyVersion"))
                if (!$util.isString(message.lobbyVersion))
                    return "lobbyVersion: string expected";
            if (message.deviceModel != null && message.hasOwnProperty("deviceModel"))
                if (!$util.isString(message.deviceModel))
                    return "deviceModel: string expected";
            if (message.deviceHeight != null && message.hasOwnProperty("deviceHeight"))
                if (!$util.isInteger(message.deviceHeight))
                    return "deviceHeight: integer expected";
            if (message.deviceWidth != null && message.hasOwnProperty("deviceWidth"))
                if (!$util.isInteger(message.deviceWidth))
                    return "deviceWidth: integer expected";
            if (message.osName != null && message.hasOwnProperty("osName"))
                if (!$util.isString(message.osName))
                    return "osName: string expected";
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                if (!$util.isString(message.osVersion))
                    return "osVersion: string expected";
            if (message.macAddr != null && message.hasOwnProperty("macAddr"))
                if (!$util.isString(message.macAddr))
                    return "macAddr: string expected";
            if (message.udid != null && message.hasOwnProperty("udid"))
                if (!$util.isString(message.udid))
                    return "udid: string expected";
            if (message.isp != null && message.hasOwnProperty("isp"))
                if (!$util.isString(message.isp))
                    return "isp: string expected";
            if (message.network != null && message.hasOwnProperty("network"))
                if (!$util.isString(message.network))
                    return "network: string expected";
            if (message.appVersion != null && message.hasOwnProperty("appVersion"))
                if (!$util.isString(message.appVersion))
                    return "appVersion: string expected";
            if (message.imei != null && message.hasOwnProperty("imei"))
                if (!$util.isString(message.imei))
                    return "imei: string expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.isEmulator != null && message.hasOwnProperty("isEmulator"))
                if (!$util.isInteger(message.isEmulator))
                    return "isEmulator: integer expected";
            return null;
        };

        /**
         * Creates a Device message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof msg.Device
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {msg.Device} Device
         */
        Device.fromObject = function fromObject(object) {
            if (object instanceof $root.msg.Device)
                return object;
            let message = new $root.msg.Device();
            if (object.lobbyVersion != null)
                message.lobbyVersion = String(object.lobbyVersion);
            if (object.deviceModel != null)
                message.deviceModel = String(object.deviceModel);
            if (object.deviceHeight != null)
                message.deviceHeight = object.deviceHeight | 0;
            if (object.deviceWidth != null)
                message.deviceWidth = object.deviceWidth | 0;
            if (object.osName != null)
                message.osName = String(object.osName);
            if (object.osVersion != null)
                message.osVersion = String(object.osVersion);
            if (object.macAddr != null)
                message.macAddr = String(object.macAddr);
            if (object.udid != null)
                message.udid = String(object.udid);
            if (object.isp != null)
                message.isp = String(object.isp);
            if (object.network != null)
                message.network = String(object.network);
            if (object.appVersion != null)
                message.appVersion = String(object.appVersion);
            if (object.imei != null)
                message.imei = String(object.imei);
            if (object.location != null)
                message.location = String(object.location);
            if (object.isEmulator != null)
                message.isEmulator = object.isEmulator | 0;
            return message;
        };

        /**
         * Creates a plain object from a Device message. Also converts values to other types if specified.
         * @function toObject
         * @memberof msg.Device
         * @static
         * @param {msg.Device} message Device
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Device.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.lobbyVersion = "";
                object.deviceModel = "";
                object.deviceHeight = 0;
                object.deviceWidth = 0;
                object.osName = "";
                object.osVersion = "";
                object.macAddr = "";
                object.udid = "";
                object.isp = "";
                object.network = "";
                object.appVersion = "";
                object.imei = "";
                object.location = "";
                object.isEmulator = 0;
            }
            if (message.lobbyVersion != null && message.hasOwnProperty("lobbyVersion"))
                object.lobbyVersion = message.lobbyVersion;
            if (message.deviceModel != null && message.hasOwnProperty("deviceModel"))
                object.deviceModel = message.deviceModel;
            if (message.deviceHeight != null && message.hasOwnProperty("deviceHeight"))
                object.deviceHeight = message.deviceHeight;
            if (message.deviceWidth != null && message.hasOwnProperty("deviceWidth"))
                object.deviceWidth = message.deviceWidth;
            if (message.osName != null && message.hasOwnProperty("osName"))
                object.osName = message.osName;
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                object.osVersion = message.osVersion;
            if (message.macAddr != null && message.hasOwnProperty("macAddr"))
                object.macAddr = message.macAddr;
            if (message.udid != null && message.hasOwnProperty("udid"))
                object.udid = message.udid;
            if (message.isp != null && message.hasOwnProperty("isp"))
                object.isp = message.isp;
            if (message.network != null && message.hasOwnProperty("network"))
                object.network = message.network;
            if (message.appVersion != null && message.hasOwnProperty("appVersion"))
                object.appVersion = message.appVersion;
            if (message.imei != null && message.hasOwnProperty("imei"))
                object.imei = message.imei;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.isEmulator != null && message.hasOwnProperty("isEmulator"))
                object.isEmulator = message.isEmulator;
            return object;
        };

        /**
         * Converts this Device to JSON.
         * @function toJSON
         * @memberof msg.Device
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Device.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Device;
    })();

    return msg;
})();

export default msg;



// WEBPACK FOOTER //
// ./src/proto/Msg.js